import React from "react";

const MarvelIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_726)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.2309 13.5516C19.5188 13.5516 15.295 25.3432 15.823 30.447C16.3509 35.5509 21.9828 34.1429 21.6308 31.151C20.9268 26.0472 24.4467 10.0317 27.7906 10.0317C30.2545 10.0317 24.9747 20.9433 26.0306 27.8071C26.7346 32.207 32.7184 30.975 32.0144 27.9831C30.0785 19.0074 36.4143 10.3837 35.5343 4.04787C35.1823 1.40796 33.5984 0 32.0144 0C26.3826 0 21.8068 11.6156 21.8068 11.6156C21.8068 11.6156 22.5107 5.10384 17.7589 4.75185C11.0711 4.39986 4.20732 21.2953 4.38332 36.6068C4.55931 41.5347 10.5431 40.6547 10.1911 36.7828C9.83915 29.9191 13.711 13.5516 17.2309 13.5516Z",
  fill: "#56B3F9"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_726"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MarvelIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;